module.exports = "#overlay {\r\n  display: none !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/print/print.component.css
// module id = ./src/app/print/print.component.css
// module chunks = main